import { Flex, Box } from '@chakra-ui/react'
import { Copy, Link as LinkIcon } from '@/icons'
import { AppMessages, useAppToast } from '@/hooks/useAppToast'
import { getTrimmedValue, TrimVariant } from '../../../helpers/getTrimmedValue'

export const CopiableLink = ({
  value,
  link,
  maxLength = 48,
  trimmedLength = 16,
  variant = TrimVariant.IN,
}: {
  value: string
  link?: string
  maxLength?: number
  trimmedLength?: number
  variant?: TrimVariant
}) => {
  const { onSuccess, onError } = useAppToast()

  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(value)
      onSuccess({ key: AppMessages.TextCopied })
    } catch {
      onError()
    }
  }

  return (
    <Flex wordBreak={'break-all'} gap={1} alignItems={'center'} justifyContent={'space-between'}>
      {getTrimmedValue(value, maxLength, trimmedLength, variant)}
      <Flex gap={1}>
        <Box cursor={'pointer'} onClick={handleCopy}>
          <Copy />
        </Box>
        {link && (
          <a href={link} target={'_blank'}>
            <LinkIcon />
          </a>
        )}
      </Flex>
    </Flex>
  )
}
